import React from 'react';

import Article from './components/article';

import { PrismicArticle } from '../../types';

type Props = {
  data: PrismicArticle;
};

const EditorialContentPage = ({ data }: Props) => {
  if (!data) return null;

  switch (data.type) {
    case 'EDITORIAL_CONTENT':
      return <Article {...data} />;
    case 'CATEGORY':
    case 'CAMPAIGN':
    case 'NEWS':
    case 'TEST_TYPE':
    default:
      return null;
  }
};

export default EditorialContentPage;
